define(
({
  "load_error": "Fehler beim Laden",
  "description": "Eine Anfrage wurde nicht ordnungsgemäß abgeschlossen. Sie sollten prüfen, ob Ihre Bestellung gespeichert wurde und diese Seite anschließend aktualisieren."
})
);
